import { render } from "./ProductionSettings.vue?vue&type=template&id=5f727998"
import script from "./ProductionSettings.vue?vue&type=script&lang=js"
export * from "./ProductionSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__